import * as React from 'react';
import { GridCell, GridColumnMenu, gridColumnPositionsSelector, gridColumnsTotalWidthSelector, useGridApiContext, } from '@mui/x-data-grid-premium';
import { MenuItem, Skeleton, Stack } from '@mui/material';
import { SkeletonGrid } from './DataGrid.styles';
export const SkeletonLoader = (props) => {
    const apiRef = useGridApiContext();
    let skeletonRowsCount;
    // @ts-expect-error Function signature expects to be called with parameters, but the implementation suggests otherwise
    const rowHeight = apiRef.current.unstable_getRowHeight();
    if (!props.skeletonRowCount) {
        const viewportHeight = apiRef.current?.rootElementRef?.current?.clientHeight ?? 0;
        skeletonRowsCount = Math.ceil(viewportHeight / rowHeight);
    }
    else {
        skeletonRowsCount = props.skeletonRowCount;
    }
    const totalWidth = gridColumnsTotalWidthSelector(apiRef);
    const positions = gridColumnPositionsSelector(apiRef);
    const inViewportCount = React.useMemo(() => positions.filter(value => value <= totalWidth).length, [totalWidth, positions]);
    const columns = apiRef.current
        .getVisibleColumns()
        .slice(0, inViewportCount);
    const children = React.useMemo(() => {
        const array = [];
        for (let i = 0; i < skeletonRowsCount; i++) {
            for (const column of columns) {
                array.push(React.createElement(Skeleton, { key: `column-${i}-${column.field}`, sx: { mx: 1 }, width: '90%' }));
            }
            array.push(React.createElement("div", { key: `fill-${i}` }));
        }
        return array;
    }, [skeletonRowsCount, columns]);
    return (React.createElement(SkeletonGrid, { columns: columns, rowHeight: rowHeight }, children));
};
export const CustomColumnMenu = (props) => {
    if (props.menuItems) {
        return (React.createElement(Stack, { px: 0.5, py: 0.5 }, props.menuItems?.map(item => (React.createElement(MenuItem, { key: item.title, onClick: e => {
                item.onClick(e, props.colDef);
                if (props.hideMenu)
                    props.hideMenu(e);
            } }, item.title)))));
    }
    return (React.createElement(GridColumnMenu, { ...props, slots: {
            columnMenuAggregationItem: null,
            columnMenuGroupingItem: null,
            ...props.slots,
        } }));
};
export const CustomContextCell = (props) => {
    const { onContextMenu, value, ...other } = props;
    return (React.createElement("div", { "aria-hidden": "true", onContextMenu: e => onContextMenu(e, value) },
        React.createElement(GridCell, { ...other }, props.value)));
};
